export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9752.250d4ca9.jpg";